import React from "react";
import { Input, Tooltip } from 'antd';

const SearchBox = ({ styleName, placeholder, onChange, onKeyDown, onSearch, value }) => {

  return (
    <div style={{ borderRadius: '12px' }} className={`gx-search-bar ${styleName}`}>
      <div className="gx-form-group">
        <Tooltip mouseEnterDelay={1} placement="bottom" title="Search by job number, Internal Reference (start with, partial), Address (partial)">
          <Input style={{ display: 'inline-flex' }} allowClear={true} className="ant-input input-search" type="search" placeholder={placeholder} onChange={onChange} onKeyDown={onKeyDown} value={value} />
        </Tooltip>
        <span style={{ display: 'inline-flex', zIndex: '99', marginLeft: '10px' }} className="gx-search-icon gx-pointer">
          <i className="icon icon-search" onClick={onSearch} />
        </span>
      </div>
    </div>
  )
};
export default SearchBox;

SearchBox.defaultProps = {
  styleName: "",
  value: "",
};
